import React from 'react';

import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import PhoneAndroidOutlinedIcon from '@material-ui/icons/PhoneAndroidOutlined';

type Props = {
  onClick: () => void;
  disabled?: boolean;
  isLogin: boolean;
};

const useStyles = makeStyles((theme) => ({
  logo: {
    width: 20,
    height: 20,
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#000080',
    color: theme.palette.common.white,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(),
  },
  grow: {
    width: 10,
  },
}));

export default function MobileButton({ onClick, disabled, isLogin }: Props) {
  const classes = useStyles();

  return (
    <Button
      variant="contained"
      size="large"
      fullWidth
      onClick={onClick}
      disabled={disabled}
      className={classes.container}
      startIcon={<PhoneAndroidOutlinedIcon className={classes.logo} />}
    >
      {isLogin ? 'Log In with Mobile' : 'Sign Up with Mobile'}
      <div className={classes.grow} />
    </Button>
  );
}
